/**
 * Referral API endpoint constants.
 */
export const REFERRAL_ENDPOINTS = {
    APPLY: '/referral/apply',
};
//# sourceMappingURL=endpoints.js.map